import React, { useState, useEffect } from "react";
import { Container, HeaderContainer } from "./styles";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Tag,
} from "antd";
import {
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import { useLanguage } from "../../hooks/LanguageContext";
import api from "../../services/api";
import { format } from "date-fns";
import { returnCatch } from "../../services/functions";

const { Option } = Select;
const { confirm } = Modal;

export default function Users() {
  const [users, setUsers] = useState([]);
  const [usersTotal, setUsersTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const { language } = useLanguage();

  const [form] = Form.useForm();

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    loadingScreen();
  }, [page, language]);

  async function loadingScreen() {
    setLoading(true);
    await api
      .get(`/admin/users?&page=${page}`)
      .then((response) => {
        setUsers(response.data.users);
        setUsersTotal(response.data.usersTotal);
      })
      .catch(({ response }) => {
        returnCatch(response);
      });
    setLoading(false);
  }

  const columns = [
    {
      title: "Usuário",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: "bold" }}>{text}</div>
          <div style={{ fontSize: "12px", color: "#666" }}>{record.email}</div>
        </div>
      ),
    },
    {
      title: "Plano",
      dataIndex: "plan_name",
      key: "plan_name",
      render: (plan) => {
        let color = "default";
        if (plan === "PREMIUM") color = "gold";
        return (
          <Tag color={color}>{plan === "PREMIUM" ? plan : "GRATUITO"}</Tag>
        );
      },
    },
    {
      title: "Data de criação",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (
        <div>
          <div style={{ fontWeight: "bold" }}>
            {format(new Date(text), "dd/MM/yyyy")}
          </div>
        </div>
      ),
    },
    {
      title: "Ações",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Ver Detalhes">
            <Button
              icon={<EyeOutlined />}
              onClick={() => handleView(record)}
              type="default"
              shape="circle"
            />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
              danger
              shape="circle"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleView = (user) => {
    setSelectedUser(user);
    setIsViewModalOpen(true);
  };

  const handleDelete = (user) => {
    confirm({
      title: "Tem certeza que deseja excluir este usuário?",
      icon: <ExclamationCircleOutlined />,
      content: `O usuário ${user.name} será removido permanentemente.`,
      okText: "Sim, Excluir",
      okType: "danger",
      cancelText: "Cancelar",
      onOk() {
        return new Promise((resolve) => {
          setTimeout(() => {
            setUsers((prev) => prev.filter((u) => u.id !== user.id));
            setTotal((prev) => prev - 1);
            toast.success("Usuário excluído com sucesso!");
            resolve();
          }, 500);
        });
      },
    });
  };

  return (
    <Container>
      <HeaderContainer>
        <h1>{usersTotal} Usuários</h1>
      </HeaderContainer>

      <Table
        columns={columns}
        dataSource={users}
        loading={loading}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 10,
          total: total,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} itens`,
        }}
        rowKey="id"
      />

      <Modal
        title="Detalhes do Usuário"
        open={isViewModalOpen}
        onCancel={() => setIsViewModalOpen(false)}
        footer={[
          <Button key="close" onClick={() => setIsViewModalOpen(false)}>
            Fechar
          </Button>,
        ]}
      >
        {selectedUser && (
          <div>
            <p>
              <strong>ID:</strong> {selectedUser.id}
            </p>
            <p>
              <strong>Nome:</strong> {selectedUser.name}
            </p>
            <p>
              <strong>Email:</strong> {selectedUser.email}
            </p>
            <p>
              <strong>Plano:</strong>
              <Tag
                style={{ marginLeft: 8 }}
                color={selectedUser.plan === "PREMIUM" ? "gold" : "default"}
              >
                {selectedUser.plan_name}
              </Tag>
            </p>
            <p>
              <strong>Cadastro:</strong>{" "}
              {format(new Date(selectedUser.created_at), "dd/MM/yyyy")}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <Tag color={selectedUser.active ? "green" : "red"}>
                {selectedUser.active ? "ATIVO" : "INATIVO"}
              </Tag>
            </p>
            <p>
              <strong>úlimo acesso:</strong>{" "}
              {format(new Date(selectedUser.accessed_at), "dd/MM/yyyy HH:mm")}
            </p>
          </div>
        )}
      </Modal>
    </Container>
  );
}
